<template>
    <div class="dashboard">
        <div class="mx-0 px-0">
            <div class="row flex-column flex-lg-row mx-0 px-0">
                <!-- Left Column -->
                <div class="col-12 col-md-12 col-xl-6 left-column mb-4 mb-lg-0 mx-0 px-0">
                    <h1 class="main-title mx-0 px-0">Efectos agudos y crónicos para la salud</h1>

                    <div class="row stats-row mx-0 px-0">
                        <div class="col-12 col-md-4 mx-0  px-0">
                            <StatsCard :value="dataDash2.total_inventory_verified" title="Productos Caracterizados" />
                        </div>
                        <div class="col-12 col-md-4 mx-0  px-0">
                            <StatsCard :value="fdsWithReview" title="FDS a Revisar" />
                        </div>
                        <div class="col-12 col-md-4  px-0">
                            <StatsCard :value="productNotDangerCount" title="Sin afectaciones para la salud" />
                        </div>
                    </div>

                    <div class="tree-section mx-0 px-0">
                        <CenterBody />
                    </div>
                </div>

                <!-- Right Column - Scrollable -->
                <div class="col-12 col-md-12 col-xl-6 right-column px-0 mx-0">
                    <div class="scrollable-content px-0 mx-0">
                        <div class="charts-container px-0 mx-0">
                            <div class="row px-0 mx-0">
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Toxicidad Aguda - Mortales" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.acute_toxicity_mortal"
                                        chartKey="acute_toxicity_mortal" :options="categoryChartOptions"
                                        :isLoading="isLoadingChartInfo['acute_toxicity_mortal']" />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 mb-4 px-0 pl-md-1">
                                    <ChartCard title="Carcinogenicidad" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.carcinogenicity" chartKey="carcinogenicity"
                                        :options="carcinogenicityChartOptions"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Componentes de priorización normativa"
                                        @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.components_priority_normative"
                                        chartKey="components_priority_normative" :options="priorityChartOptions"
                                        @page-changed="handlePriorityPageChange"
                                        :isLoading="isLoadingChartInfo['components_priority_normative']"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 mb-4 px-0 pl-md-1">
                                    <ChartCard title="Toxicidad específica de órganos diana" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.target_organs" chartKey="target_organs"
                                        :options="toxycityTargetOrgans"
                                        :isLoading="isLoadingChartInfo['target_organs']"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Toxicidad Aguda – Tóxicos" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.toxicity_agude_toxicity" chartKey="toxicity_agude_toxicity"
                                        :options="toxycityAgude"
                                        :isLoading="isLoadingChartInfo['toxicity_agude_toxicity']"
                                        />
                                </div>
                                <div class="col-12 col-xl-6 col-md-12 mb-4 mb-4 px-0 pl-md-1">
                                    <ChartCard title="Neurotóxicos" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.neurotoxic" chartKey="neurotoxic"
                                        :options="neurotoxicChartOptions"
                                        :isLoading="isLoadingChartInfo['neurotoxic']"
                                        />
                                </div>
                                
                               
                                <div class="col-12 col-xl-6 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Sensibilizantes" @chart-info-click="handleChartInfo"
                                        :showInfoButton="chartInfoButtons.sensitizing" chartKey="sensitizing"
                                        :options="sensitizingChartOptions"
                                        :isLoading="isLoadingChartInfo['sensitizing']"
                                        />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductListModal :modal-id="'products-modal'" :title="modalTitle" :products="selectedProducts"
        :keyProduct="keyProducts"
        />
        <NormativeModal :modal-id="'normative-modal'" />
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ChartCard from '../components/health/ChartCard.vue';
import IndicatorCard from '../components/health/IndicatorCard.vue';
import StatsCard from '../components/health/StatsCard.vue';
import CenterBody from '../components/health/CenterBody.vue';
import ProductListModal from '../components/ProductListModal.vue';
import NormativeModal from '../components/NormativeModal.vue';
import {
    getCategoryChartOptions,
    getCarcinogenicityChartOptions,
    getPriorityChartOptions,
    productsChartOptions,
    healthEffectsChartOptions,
    sensitizersChartOptions,
    getReprotoxicityChartOptions,
    getOtoxicityChartOptions,
    getMutagenicityChartOptions,
    getHealthCategoriesChartOptions,
    getNeurotoxicChartOptions,
    getCorrosiveChartOptions,
    getSensitizingChartOptions,
    getAgutetoxicityChartOptions,
    getTargetOrgansChartOptions,
    getComponentForNormativeOptions
} from '../config/chartOptions';

export default {
    name: 'Health',
    components: {
        ChartCard,
        IndicatorCard,
        StatsCard,
        CenterBody,
        ProductListModal,
        NormativeModal,
    },
    data() {
        return {
            priorityCurrentPage: 1,
            productsChartOptions,
            healthEffectsChartOptions,
            sensitizersChartOptions,
            modalTitle: '',
            selectedProducts: [],
            chartInfoButtons: {
                acute_toxicity_mortal: true,
                carcinogenicity: true,
                components_priority_normative: true,
                reprotoxicity: true,
                otoxicity: true,
                neurotoxic: true,
                corrosive: true,
                mutagenicity: true,
                sensitizing: true,
                products_by_location: false,
                target_organs: true,
                toxicity_agude_toxicity: true
            },
            isLoadingChartInfo: {},
            keyProducts: null
        };
    },
    computed: {
        ...mapState("dashboard", ["dataDash1", "dataDash2", "dashboardFilters", "productsDashAffected"]),
        categoryChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCategoryChartOptions(this.dataDash2);
        },
        carcinogenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCarcinogenicityChartOptions(this.dataDash2);
        },
        priorityFullData() {
            return (this.dataDash2 && this.dataDash2.components_priority_normative) || [];
        },
        priorityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getComponentForNormativeOptions(this.dataDash2);
        },
        reprotoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getReprotoxicityChartOptions(this.dataDash2);
        },
        otoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getOtoxicityChartOptions(this.dataDash2);
        },
        mutagenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getMutagenicityChartOptions(this.dataDash2);
        },
        healthCategoriesChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getHealthCategoriesChartOptions(this.dataDash2);
        },
        neurotoxicChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getNeurotoxicChartOptions(this.dataDash2);
        },
        corrosiveChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCorrosiveChartOptions(this.dataDash2);
        },
        sensitizingChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getSensitizingChartOptions(this.dataDash2);
        },
        fdsWithReview() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return this.dataDash2.attachment_not_revision;
        },
        productNotDangerCount() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return this.dataDash2.product_not_danger_count;
        },
        toxycityAgude(){
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return getAgutetoxicityChartOptions(this.dataDash2);
        },
        toxycityTargetOrgans(){
            if (!this.dataDash2 || !this.dataDash2.consulted) return 0;
            return getTargetOrgansChartOptions(this.dataDash2);
        },
    },
    methods: {
        ...mapActions("dashboard", ["findDataProducts"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),

        handlePriorityPageChange(newPage) {
            this.priorityCurrentPage = newPage;
        },
        async handleChartInfo({ key, title }) {
    this.keyProducts = key
    this.$set(this.isLoadingChartInfo, key, true);
    this.modalTitle = title;
    this.resetProductsDashAffected();

    try {
        if (key === 'components_priority_normative') {
            this.$bvModal.show('normative-modal');
        } else {
            const filters = {
                ...this.dashboardFilters,
                affectation: key,
            };
            await this.findDataProducts(filters);
            this.selectedProducts = this.productsDashAffected;
            this.$bvModal.show('products-modal');
        }
    } catch (error) {
        console.error('Error al cargar los productos:', error);
    }
    finally {
        this.$set(this.isLoadingChartInfo, key, false);
    }
}

    }
};
</script>

<style scoped>
.dashboard {
    background-color: #00000000;
    min-height: 100vh;
}

.main-title {
    position: relative;
    margin-bottom: 0;
    font-size: 2.2rem;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}



.right-column {
    height: 80vh;
    display: flex;
    flex-direction: column;
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding-right: 1rem;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.scrollable-content::-webkit-scrollbar {
    display: none;
}
</style>
